const Services = () => (
  <section className="centered-section" style={{ textAlign: 'center' }}>
    <div className="translucent-box">
      <h2 className="main-heading">Services</h2>
      <ul className="styled-list">
        <li>Kitchen Knife Sharpening</li>
        <li>Scissors & Shears</li>
        <li>Garden Tools</li>
        <li>Custom Blade Polishing</li>
      </ul>
      <div className="military-benefit">
        <strong>Thank you for your service!</strong>
        <p>Active military, veterans, firefighters, and emergency medical sevices get 1 personal knife sharpened for free for life.</p>
      </div>
    </div>
  </section>
);

export default Services;
